// @see https://en.wikipedia.org/wiki/European_Union_value_added_tax#cite_note-reason2-65

export const euCountries = [
  // EU 27:
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland, Republic of (EIRE)
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
];

export const franceCountryCodes = [
  'FR', // France
  'MC', // Monaco
  'GP', // Guadeloupe
  'MQ', // Martinique
  'RE', // Réunion

  // 'GF', // French Guiana
  // 'YT', // Mayotte

  // 'PM', // Saint Pierre and Miquelon
  // 'BL', // Saint Bartelemey
  // 'MF', // Saint Martin
  // 'WF', // Wallis and Futuna
  // 'PF', // French Polynesia
  // 'NC', // New Caledonia
  // 'TF', // French Southern Territories
];

// Countries for which a VAT number is mandatory on the billing information.
export const vatNumberRequiredCountries = [
  ...euCountries,
  ...franceCountryCodes,
];
